import { useTranslation } from "react-i18next";
import { LegalModal } from "./LegalModal";
import { LegalSection } from "./LegalSection";

export const TermsOfService = () => {
  const { t } = useTranslation();

  return (
    <LegalModal title={t("legal.terms.title")}>
      <div className="space-y-6">
        {/* Metadata Header */}
        <div className="mb-8 p-4 bg-muted/30 rounded-lg space-y-2 text-sm">
          <p><strong>Effective Date:</strong> To be determined (Launch Date)</p>
          <p><strong>Last Updated:</strong> 14 October 2025</p>
          <p><strong>Company:</strong> Narrate BV t/a Momentum Lab</p>
          <p><strong>Contact:</strong> <a href="mailto:legal@momentumlab.earth" className="text-brand-teal hover:underline">legal@momentumlab.earth</a></p>
        </div>

        <LegalSection title={t("legal.terms.section1.title")}>
          <p>{t("legal.terms.section1.content")}</p>
          <p>By accessing or using the Momentum Lab platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
        </LegalSection>

        <LegalSection title={t("legal.terms.section2.title")}>
          <p>{t("legal.terms.section2.content")}</p>
          <p>Momentum Lab provides an integrated sustainability learning and action platform that enables organisations to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Access curated sustainability curricula and resources</li>
            <li>Track progress on sustainability initiatives</li>
            <li>Connect with sustainability professionals and experts</li>
            <li>Measure and report on sustainability impact</li>
          </ul>
        </LegalSection>

        <LegalSection title="User Accounts and Registration">
          <p>To access certain features, you may be required to create an account. You agree to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain the security of your password and account</li>
            <li>Notify us immediately of any unauthorised use</li>
            <li>Be responsible for all activities under your account</li>
          </ul>
        </LegalSection>

        <LegalSection title={t("legal.terms.section3.title")}>
          <p>{t("legal.terms.section3.content")}</p>
          <p>As a user, you agree NOT to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Violate any laws or regulations</li>
            <li>Infringe on intellectual property rights</li>
            <li>Transmit harmful code or malware</li>
            <li>Attempt to gain unauthorised access to our systems</li>
            <li>Use the platform for spam or commercial solicitation</li>
            <li>Impersonate others or provide false information</li>
          </ul>
        </LegalSection>

        <LegalSection title="Intellectual Property">
          <p>All content, features, and functionality on the Momentum Lab platform are owned by Narrate BV and protected by international copyright, trademark, and other intellectual property laws.</p>
          <p>You may not reproduce, distribute, modify, or create derivative works without our express written permission.</p>
        </LegalSection>

        <LegalSection title="Account Termination">
          <p>We reserve the right to suspend or terminate your account at our discretion if:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>You violate these Terms of Service</li>
            <li>Your use poses a security or legal risk</li>
            <li>Your account remains inactive for an extended period</li>
            <li>We discontinue the service</li>
          </ul>
          <p>You may terminate your account at any time by contacting us at <a href="mailto:legal@momentumlab.earth" className="text-brand-teal hover:underline">legal@momentumlab.earth</a>.</p>
        </LegalSection>

        <LegalSection title="Limitation of Liability">
          <p>To the fullest extent permitted by law, Momentum Lab shall not be liable for:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Indirect, incidental, special, or consequential damages</li>
            <li>Loss of profits, data, or business opportunities</li>
            <li>Damages resulting from unauthorised access or use</li>
            <li>Service interruptions or technical failures</li>
          </ul>
          <p>Our total liability shall not exceed the amount you paid for our services in the 12 months preceding the claim.</p>
        </LegalSection>

        <LegalSection title="Dispute Resolution">
          <p>Any disputes arising from these terms shall be resolved through:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Negotiation:</strong> Good faith discussions to resolve the matter</li>
            <li><strong>Mediation:</strong> Facilitated mediation if negotiation fails</li>
            <li><strong>Arbitration:</strong> Binding arbitration under Dutch law</li>
          </ul>
        </LegalSection>

        <LegalSection title="Governing Law">
          <p>These Terms of Service are governed by the laws of the Netherlands. Any legal proceedings shall be conducted in the competent courts of Amsterdam, the Netherlands.</p>
        </LegalSection>

        <LegalSection title="Force Majeure">
          <p>We shall not be liable for any failure to perform our obligations due to circumstances beyond our reasonable control, including natural disasters, war, terrorism, riots, embargoes, acts of civil or military authorities, fire, floods, pandemics, or failures in telecommunications infrastructure.</p>
        </LegalSection>

        <LegalSection title={t("legal.terms.section4.title")}>
          <p>{t("legal.terms.section4.content")}</p>
          <p>We will notify you of material changes via email or through a notice on our platform. Your continued use after changes take effect constitutes acceptance of the revised terms.</p>
        </LegalSection>

        {/* Contact Footer */}
        <div className="mt-8 pt-6 border-t border-border text-center">
          <p className="text-foreground/70 tracking-wide">
            Questions about these terms? Contact us at{' '}
            <a href="mailto:legal@momentumlab.earth" className="text-brand-teal hover:underline">
              legal@momentumlab.earth
            </a>
          </p>
        </div>
      </div>
    </LegalModal>
  );
};
